/**
 * Locked-aspect resize helpers (Figma-style: editing one axis updates the other).
 */

export function aspectRatioFromNatural(naturalWidth, naturalHeight) {
  if (!naturalWidth || !naturalHeight) return 1;
  return naturalWidth / naturalHeight;
}

export function heightFromWidth(width, naturalWidth, naturalHeight) {
  const w = Number(width);
  if (!Number.isFinite(w) || w < 1) return null;
  const ratio = aspectRatioFromNatural(naturalWidth, naturalHeight);
  return Math.max(1, Math.round(w / ratio));
}

export function widthFromHeight(height, naturalWidth, naturalHeight) {
  const h = Number(height);
  if (!Number.isFinite(h) || h < 1) return null;
  const ratio = aspectRatioFromNatural(naturalWidth, naturalHeight);
  return Math.max(1, Math.round(h * ratio));
}

/**
 * Clamp width/height to source pixels (shrink-only preview semantics).
 */
export function clampResizeDimensions(width, height, naturalWidth, naturalHeight) {
  let w = Math.round(Number(width));
  let h = Math.round(Number(height));
  if (!Number.isFinite(w) || !Number.isFinite(h) || w < 1 || h < 1) {
    return null;
  }
  if (typeof naturalWidth === 'number' && typeof naturalHeight === 'number') {
    w = Math.min(w, naturalWidth);
    h = Math.min(h, naturalHeight);
  }
  return { width: w, height: h };
}
